// Chapter 2 writing frames ("מסגרות"), approved by Shlomo 26.10.2026.
// One frame per section; all ten work on the single event the reader
// names in step 1 ("האריה שלך"). Mounted by App.tsx at the
// <div data-widget-anchor="ch2_fN"> anchors in src/chapters/chapter-2.html.
// Answers persist in progress.fields under keys `${id}_${i}` (one textarea)
// or `${id}_${i}_c1` / `_c2` (two columns).
import type { Frame } from "./frames";

export type Ch2Frame = Frame;

export const CH2_FRAMES: Ch2Frame[] = [
  {
    "id": "ch2_f1",
    "n": "2.1",
    "title": "האריה שלי",
    "type": "lines",
    "intro": "שלוש שורות, עובדות בלבד, בלי פרשנות. אין נכון ולא נכון.",
    "fields": [
      "השם שנתתי לו:",
      "מה קרה (מה נאמר, מה נעשה):",
      "מה הגוף שלי עשה (לב, בטן, כתפיים, נשימה):"
    ]
  },
  {
    "id": "ch2_f2",
    "n": "2.2",
    "title": "הירושה שלי",
    "type": "twocol",
    "intro": "",
    "fields": [
      "ממה אמא (או סבתא) פחדה|ממה אבא (או סבא) פחד",
      "מה מזה עדיין איתי|מה מזה כבר לא איתי"
    ]
  },
  {
    "id": "ch2_f3",
    "n": "2.3",
    "title": "שני מספרים",
    "type": "scale",
    "intro": "הקיפי מספר בכל שורה.",
    "fields": [
      "האזעקה בגוף שלי",
      "הסכנה האמיתית שהיתה שם"
    ]
  },
  {
    "id": "ch2_f4",
    "n": "2.4",
    "title": "משפט אחד",
    "type": "oneline",
    "intro": "בלי הפחד, באירוע הזה הייתי...",
    "fields": [
      "בלי הפחד, הייתי:"
    ]
  },
  {
    "id": "ch2_f5",
    "n": "2.5",
    "title": "שלושת הצעדים של האריה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "קלטתי (רק העובדה):",
      "פירקתי לפרטים (טון, פנים, מילים):",
      "השוויתי ל... (מה זה הזכיר לי):"
    ]
  },
  {
    "id": "ch2_f6",
    "n": "2.6",
    "title": "לפני ואחרי",
    "type": "twocol",
    "intro": "",
    "fields": [
      "האריה לפני תרגיל הנשימות (מילה או שתיים)|האריה אחרי תרגיל הנשימות",
      "מה בגוף השתנה|מה לא השתנה"
    ]
  },
  {
    "id": "ch2_f7",
    "n": "2.7",
    "title": "הסיפור מהצד השני",
    "type": "lines",
    "intro": "שלושה משפטים, בגוף ראשון, כאילו את הוא או היא.",
    "fields": [
      "מה ראיתי:",
      "מה התכוונתי:",
      "מה לא ידעתי:"
    ]
  },
  {
    "id": "ch2_f8",
    "n": "2.8",
    "title": "המשפט",
    "type": "oneline",
    "intro": "",
    "fields": [
      "כש..."
    ]
  },
  {
    "id": "ch2_f9",
    "n": "2.9",
    "title": "שני עננים",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "ענן המהיר (בשלוש השניות הראשונות)|ענן האיטי (היום)",
      "מי צדק (המהיר / האיטי):"
    ]
  },
  {
    "id": "ch2_f10",
    "n": "2.10",
    "title": "האריה שלי, גרסה שלישית",
    "type": "final",
    "intro": "",
    "fields": [
      "סכנת מוות מיידית? (מילה אחת):",
      "מה קרה (שלוש שורות, מהיום):",
      "",
      "",
      "מה השתנה בין הגרסה הראשונה לשלישית:",
      "השבוע הקרוב, V על כל פעם ששאלתי:"
    ]
  }
];
